import { Autocomplete, Box, Grid, TextField, Typography, useMediaQuery, RadioGroup, FormControlLabel, Radio, Tooltip, IconButton, CircularProgress } from "@mui/material";
import FormModal from "../../../common/formModal";
import Styles from "../../../theme/commonCss/Styles";
import { Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { ReactComponent as EditIcon } from '../../../assets/icons/main/create-icon.svg';
import { ReactComponent as CloseIcon } from '../../../assets/icons/main/close-icon.svg';
import CheckboxComponent from "../../../components/Checkbox";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import RadioComponent from "../../../components/Radio";
import dayjs from "dayjs";
import TimePickerComponent from "../components/TimePickerComponent";
import Ajv from 'ajv';
import AjvErrors from 'ajv-errors';
import { assignTaskSchema } from "./formSchema";
import { connect, useDispatch } from "react-redux";
import { maintenanceManagementActions } from "../../../store/reducers/maintenance-management";
import { useTheme } from "@emotion/react";
import { palette } from "../../../theme/palette";
import { get, isEmpty } from "lodash";

const FIELDS = [
  { name: 'mt_name', label: 'Machine / Line', disabled: true, type: 'input', required: true },
  { name: 'onto_manage_id', label: 'Selected Ontology', disabled: true, type: 'input' },
  { name: 'assigned_to', label: 'Select Engineer', type: 'select', required: true },
  {
    name: 'start_date',
    label: 'Select Date & Time',
    disabled: true,
    type: 'date_time',
    required: true,
  },
  {
    name: 'schedule_type',
    label: 'Schedule Type',
    type: 'radio',
    required: true,
  },
  { name: 'mt_remarks', label: 'Remarks', type: 'text' },
];

const AssignTask = ({
  isOpen,
  closeModal = () => { },
  isEdit,
  assignTaskData,
  engineers,
  updateMaintenancePlanLoading
}: any) => {
  const ajv = new Ajv({ allErrors: true });
  AjvErrors(ajv);
  const dispatch = useDispatch();
  const [ajvErrors, setAjvErrors] = useState<any>({});
  const themeData: any = useTheme();
  const responsiveSize = useMediaQuery('(max-width:900px)');
  const [formData, setFormData] = useState({
    schedule_type: '',
    ...assignTaskData,
    assigned_to: engineers.find((engineer: any) => engineer.id === assignTaskData.assigned_to) || null,
  });
  const [readOnly, setReadOnly] = useState<any>(true);

  useEffect(() => {
    if (!isEmpty(assignTaskData)) {
      setFormData({ ...formData, mt_type: assignTaskData.mt_type, schedule_type: assignTaskData.mt_type === "corrective" ? 'occurrence' : assignTaskData.schedule_type })
    }
  }, [assignTaskData])

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const validate = ajv.compile(assignTaskSchema);

    const params = {
      ...formData,
      start_date: dayjs(formData.start_date).format('MMM-DD-YYYY'),
      assigned_to: formData.assigned_to?.id || null,
      schedule_type: formData.schedule_type || '',
    };

    if (validate({ ...params })) {
      delete params.ontologyList;
      delete params.mt_id;

      const payload = new FormData();
      payload.append('maintenance', JSON.stringify({...params,current_task_date: get(params,'current_task_date', null)}));
      payload.append('maintenance_id', formData.mt_id);

      dispatch(maintenanceManagementActions.updateMaintenancePlanRequest(payload));
      setAjvErrors({});
    } else {
      if (validate.errors) {
        // console.log(validate.errors, 'ERRORS*')
        setAjvErrors(validate.errors[0]);
      }
    }

  };

  const closePopup = () => {
    closeModal();
    setAjvErrors({});
    setFormData({})
  }

  const handleRadioChange = (event: any) => {
    setFormData({ ...formData, schedule_type: event.target.value });
  }

  const handleEngineerChange = (event: any, value: any) => {
    setFormData({ ...formData, assigned_to: value });
  };

  const OntologyListComponent = ({ }: any) => {
    const ontoList = assignTaskData.ontologyList && assignTaskData.ontologyList.length
      ? assignTaskData.ontologyList.map((item: any, index: number) =>
        assignTaskData.ontologyList.length > 1 ? (
          index === assignTaskData.ontologyList.length - 1 ? (
            item.onto_manage_title + ','
          ) : (
            item.onto_manage_title
          )
        ) : (
          item.onto_manage_title
        )
      )
      : '';

    return (
      <TextField sx={{ '&.MuiTextField-root': { margin: '0px' }, }} margin='normal' fullWidth variant='outlined' size='small' value={ontoList} disabled={true} />
    );
  };


  return (
    <FormModal
      title={isEdit ? 'UPDATE ASSIGN TASK' : 'ASSIGN TASK'}
      isOpen={isOpen}
      handleClose={closePopup}
      handleSubmit={handleSubmit}
    >
      {(updateMaintenancePlanLoading) && (
        <Box
          style={{
            height: '100%',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
            zIndex: 10,
          }}
        >
          <CircularProgress />
        </Box>
      )}
      <Grid
        container
        spacing={1}
        textAlign={'right'}
        sx={{
          ...Styles.gridContainer,
          '&.MuiGrid-root': {
            paddingBottom: '20px !important',
          },
          marginLeft: 0,
          marginTop: responsiveSize ? '0px' : '12px',
        }}
      >
        {FIELDS.map((field: any) => {
          if (field.type === 'input') {
            return (
              <Fragment key={field.name}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={4}
                  sx={{
                    ...Styles.gridItem,
                    '&.MuiGrid-item': {
                      paddingTop: '24px !important',
                      pl: '0px !important',
                      justifyContent: responsiveSize ? 'flex-start' : 'flex-end',
                    },
                  }}
                >
                  <Typography sx={Styles.inputLabel} className={field.required ? 'required-field' : ''}>{field.label}</Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={8}
                  sx={{
                    '&.MuiGrid-item': {
                      padding: responsiveSize ? '4px 0 0' : '12px 0px',
                      pl: '0px',
                    },
                  }}
                >
                  {field.name === 'onto_manage_id' ? (
                    <OntologyListComponent />
                  ) : (
                    <TextField
                      sx={{ '&.MuiTextField-root': { margin: '0px' } }}
                      margin='normal'
                      fullWidth
                      variant='outlined'
                      size='small'
                      value={assignTaskData['mt_name']}
                      name='machineName'
                      disabled={field.disabled}
                    />
                  )}
                </Grid>
              </Fragment>
            );
          } else if (field.type === 'select') {
            return (
              <Fragment key={field.name}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={4}
                  sx={{
                    ...Styles.gridItem,
                    '&.MuiGrid-item': {
                      paddingTop: '24px !important',
                      pl: '0px !important',
                      justifyContent: responsiveSize ? 'flex-start' : 'flex-end',
                    },
                  }}
                >
                  <Typography sx={Styles.inputLabel} className={field.required ? 'required-field' : ''}>
                    {field.label}
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={8}
                  sx={{
                    '&.MuiGrid-item': {
                      padding: responsiveSize ? '4px 0 0 0' : '12px 0px',
                    },
                  }}
                >
                  <Autocomplete
                    value={formData.assigned_to}
                    options={engineers}
                    onChange={handleEngineerChange}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.full_name}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    renderOption={(props, option, { selected }) => {
                      const { key, ...optionProps } = props;
                      return (
                        <li key={key} {...optionProps}>
                          <CheckboxComponent
                            icon={<CheckBoxOutlineBlankIcon />}
                            checkedIcon={<CheckBoxIcon />}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.full_name}
                        </li>
                      );
                    }}
                    sx={{
                      '& .MuiAutocomplete-inputRoot': {
                        flexWrap: 'nowrap',
                      },
                      '& .MuiAutocomplete-tag': {
                        color: palette.info.dark,
                        '& .MuiSvgIcon-root': {
                          color: palette.info.dark,
                          opacity: '0.7',
                        },
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={formData.assign_to ? '' : 'List of Engineer'}
                        sx={{ height: 'auto' }}
                        error={ajvErrors.instancePath && ajvErrors.instancePath.includes('assigned_to')}
                        helperText={
                          ajvErrors.instancePath &&
                          ajvErrors.instancePath.includes('assigned_to') &&
                          ajvErrors.message
                        }
                      />
                    )}
                  />
                </Grid>
              </Fragment>
            );
          } else if (field.type === 'date_time') {
            const currentTaskDate = get(formData, 'current_task_date', null);
            const preventiveNextTaskDate =
              currentTaskDate && new Date(currentTaskDate) > new Date() ? currentTaskDate : formData.next_task_date;
            return (
              <Fragment key={field.name}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={4}
                  sx={{
                    ...Styles.gridItem,
                    '&.MuiGrid-item': {
                      paddingTop: '24px !important',
                      pl: '0px !important',
                      justifyContent: responsiveSize ? 'flex-start' : 'flex-end',
                    },
                  }}
                >
                  <Typography sx={Styles.inputLabel} className={field.required ? 'required-field' : ''}>
                    {field.label}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={8}
                  sx={{
                    '&.MuiGrid-item': {
                      padding: responsiveSize ? '4px 0 0 0' : '12px 0px',
                    },
                  }}
                >
                  <Grid container spacing={1}>
                    <Grid item xs={6} sx={{ paddingRight: '12px' }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          disabled={readOnly}
                          minDate={formData.mt_type === "preventive" ? formData.next_task_date ? dayjs(preventiveNextTaskDate).local() : dayjs(new Date()) : formData.start_date ? dayjs(formData.start_date) : dayjs(new Date())}
                          defaultValue={formData.mt_type === "preventive" ? formData.next_task_date ? dayjs(preventiveNextTaskDate).local() : dayjs(new Date()) : formData.start_date ? dayjs(formData.start_date) : dayjs(new Date())}
                          name='start_date'
                          onChange={(newValue) => {
                            setFormData({ ...formData, start_date: newValue });
                          }}
                          sx={{
                            '& .MuiPaper-root': {
                              backgroundColor: 'red',
                            },
                            '& .MuiPickerDay-root': {
                              backgroundColor: 'red',
                            },
                          }}
                          value={
                            formData.mt_type === 'preventive'
                              ? dayjs(preventiveNextTaskDate).local()
                              : dayjs(formData.start_date).local()
                          }
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={5} sx={{ paddingRight: '12px' }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePickerComponent
                          disabled
                          width='95%'
                          name='mt_time'
                          value={dayjs.utc(formData.mt_time, 'HH:mm:ss').local().format('hh:mm A')}
                          onSave={(newValue: any) => {
                            setFormData({ ...formData, mt_time: newValue });
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={1} sx={{ display: 'flex', alignItems: 'center' }}>
                      <IconButton onClick={() => {
                        if (readOnly) {
                          setReadOnly(false);
                        } else {
                          setReadOnly(true);
                        }
                      }}>
                        {(readOnly) ? <EditIcon style={{ color: themeData.palette.custom.light }} /> : <CloseIcon style={{ color: themeData.palette.custom.light }} />}
                      </IconButton>
                    </Grid>
                  </Grid>
                </Grid>
              </Fragment>
            );
          } else if (field.type === 'radio') {
            if (assignTaskData.mt_type != "corrective") {
              return (
                <Fragment key={field.name}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={4}
                    sx={{
                      ...Styles.gridItem,
                      '&.MuiGrid-item': {
                        paddingTop: '24px !important',
                        pl: '0px !important',
                        justifyContent: responsiveSize ? 'flex-start' : 'flex-end',
                      },
                    }}
                  >
                    <Typography sx={Styles.inputLabel} className={field.required ? 'required-field' : ''}>
                      {field.label}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={8}
                    sx={{
                      '&.MuiGrid-item': {
                        padding: responsiveSize ? '4px 0 0 0' : '12px 0px',
                      },
                    }}
                  >
                    <Grid
                      container
                      xs={12}
                      display={'flex'}
                      justifyContent={'center'}
                      alignItems={'flex-start'}
                      flexDirection={'column'}
                      sx={{ ml: '4px' }}
                    >
                      <RadioGroup
                        value={formData.schedule_type}
                        onChange={handleRadioChange}
                        row
                      >
                        <FormControlLabel
                          value='occurrence'
                          control={<RadioComponent />}
                          label='Occurrence'
                          sx={{
                            marginRight: '33px',
                            '.MuiFormControlLabel-label': {
                              fontWeight: 400,
                              fontSize: '20px',
                            },
                          }}
                        />
                        <FormControlLabel
                          value='series'
                          control={<RadioComponent />}
                          label='Series'
                          sx={{
                            '.MuiFormControlLabel-label': {
                              fontWeight: 400,
                              fontSize: '20px',
                            },
                          }}
                        />
                      </RadioGroup>
                      {ajvErrors.instancePath && ajvErrors.instancePath.includes('schedule_type') && (
                        <Typography
                          variant='body2'
                          color='error'
                          sx={{ fontWeight: '400', fontSize: '1rem', lineHeight: '22px', mt: 2 }}
                        >
                          {ajvErrors.message}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </Fragment>
              )
            }
          } else if (field.type === 'text') {
            return (
              <Fragment key={field.name}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={4}
                  sx={{
                    ...Styles.gridItem,
                    '&.MuiGrid-item': {
                      paddingTop: '24px !important',
                      pl: '0px !important',
                      justifyContent: responsiveSize ? 'flex-start' : 'flex-end',
                    },
                  }}
                >
                  <Typography sx={Styles.inputLabel}>{field.label}</Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={8}
                  sx={{
                    '&.MuiGrid-item': {
                      padding: responsiveSize ? '4px 0 0' : '12px 0px',
                      pl: '0px',
                    },
                  }}
                >
                  <TextField
                    sx={{
                      '&.MuiTextField-root': { margin: '0px' },
                      '& .MuiOutlinedInput-root': { height: 'auto' },
                    }}
                    margin='normal'
                    multiline
                    rows={4}
                    maxRows={4}
                    fullWidth
                    variant='outlined'
                    size='small'
                    value={formData.mt_remarks || ''}
                    onChange={(e) => setFormData({ ...formData, mt_remarks: e.target.value })}
                    error={ajvErrors.instancePath && ajvErrors.instancePath.includes('mt_remarks')}
                    helperText={
                      ajvErrors.instancePath &&
                      ajvErrors.instancePath.includes('mt_remarks') &&
                      ajvErrors.message
                    }
                  />
                </Grid>
              </Fragment>
            );
          }
          return <></>
        })}
      </Grid>
    </FormModal>
  );
}

const mapStateToProps = (state: any) => ({
  updateMaintenancePlanLoading: state.maintenanceManagement.updateMaintenancePlanLoading,
  updateMaintenancePlanSuccess: state.maintenanceManagement.updateMaintenancePlanSuccess,
});

export default connect(mapStateToProps)(AssignTask);